namespace TabAurous.Production {
    export interface WIPMovementForm {
        TransId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        ProductId: Serenity.IntegerEditor;
        DepartmentId: Serenity.LookupEditor;
        BagNo: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class WIPMovementForm extends Serenity.PrefixedContext {
        static formKey = 'Production.WIPMovement';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WIPMovementForm.init)  {
                WIPMovementForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(WIPMovementForm, [
                    'TransId', w0,
                    'RefTransId', w0,
                    'TransItemId', w0,
                    'RefTransItemId', w0,
                    'VoucherTypeId', w1,
                    'RefVoucherId', w1,
                    'ProductId', w1,
                    'DepartmentId', w2,
                    'BagNo', w0,
                    'Line_No', w0,
                    'SKU', w0,
                    'Pieces', w1,
                    'Weight', w3,
                    'NetWeight', w3,
                    'FinancialYearId', w1,
                    'CompanyId', w1
                ]);
            }
        }
    }
}
